
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import CarNumber from "@/components/CarNumber.vue";
  import FormBuilderField from "@/modules/FormBuilder/components/FormBuilderField.vue";
  import {IRequestAuth} from "@/modules/Auth/interfaces/request-auth.interface";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import {authResource} from "@/modules/Auth/resources/auth.resources";
  import {IAppState} from "@/interfaces/app-state.interface";

  @Component({
    components: {
      AppDialog,
      CarNumber,
      FormBuilderField,
    },
  })
  export default class LoginSelectCorpPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'auth', dialogName: 'loginSelectCorp' };
    loginId = null;
    hideContent = false;
    userCorps: IRequestAuth.ILoginUserCorpsData[] = [];

    get storeState(): IAppState { return this.$store.state; }
    get payloadPopup(): {
      userCorps: IRequestAuth.ILoginUserCorpsData[];
      reLogin?: boolean;
    } {
      return this.$store.getters['dialog/getPopupPayload'](this.currentPopup);
    }

    mounted() {
      this.userCorps = [...this.payloadPopup.userCorps];

      let loginId = +localStorage.getItem(IAuth.LocalStorageKeys.LoginSelectCorp);
      if (loginId) {
        let corp = this.userCorps.find(item => item.loginId === loginId);
        if (corp) this.loginId = loginId;
      }
    }

    saveLoginId() {
      localStorage.setItem(IAuth.LocalStorageKeys.LoginSelectCorp, this.loginId);
    }

    async loginAction() {
      let loginId = this.loginId;
      await this.onClose();
      if (this.payloadPopup.reLogin) await this.$store.dispatch('profile/reLogin', { loginId });
      else await this.$store.dispatch('auth/login', { loginId });
    }

    async removeCorp(corp: IRequestAuth.ILoginUserCorpsData) {
      this.hideContent = true;
      const text = corp.privatFlag
        ? `Вы удаляете корпорацию "${corp.corpName}", у которой есть доступ к частной парковке. Удалить?`
        : `Удалить корпорацию "${corp.corpName}"?`;
      await this.$store.dispatch('confirm/open', {
        title: 'Внимание',
        text,
        cancel: {
          text: 'Отменить',
          action: () => this.hideContent = false,
        },
        confirm: {
          text: 'Удалить',
          action: () => {
            this.hideContent = false;
            this.removeCorpResource(corp);
          },
        },
      });
    }

    async removeCorpResource(corp: IRequestAuth.ILoginUserCorpsData) {
      let request = await authResource.removeCorp({ corp });
      if (request.success) {
        if (request.response && request.response.length) {
          if (request.response.length === 1) {
            this.loginId = request.response[0].loginId;
            this.loginAction();
          }
          else {
            Vue.set(this, 'userCorps', [...request.response]);
          }
        }

        this.$notify({
          title: 'Успешно',
          message: 'Корпорация успешно удалена',
          type: 'success'
        });
      }
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
